<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false">Close</v-btn>
    </v-snackbar>

    <ClientNav />

    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>

      <v-col cols="12" lg="9" xl="10">
        <v-card>
          <v-tabs v-model="tab">
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item">
              <template>
                <v-card class="pa-2" outlined tile height="100%">
                  <DataTable
                    :headers="headers"
                    :items="inventories"
                    :server-items-length="pagination.total"
                    :loading="isLoading"
                    :search="searchKeyword"
                    :items-per-page="itemsPerPage"
                    title="Medication Inventory"
                    :isAuditorRole="isAuditorRole"
                    @fetch-data="fetchItem"
                    @update:options="handlePagination"
                    @update:search="handleSearch"
                    @on-view-item="onViewItem"
                    @on-delete-item="onDeleteItem"
                  >
                    <template v-slot:headerAction>
                      <action-control-menu
                        ref="actions"
                        :actions="['Print', 'Download']"
                        :navigateTo="navigateTo"
                        :payload="payload"
                        :isAuditorRole="isAuditorRole"
                        btnTitle="New"
                      />
                    </template>
                  </DataTable>
                </v-card>
              </template>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <OptionMenu :onAction="handleActions" :showActions="showActions" />

    <Foot class="hideOnPrint" />
  </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import renameFileHelper from "../../mixins/renameFileHelper";
import DataTable from "@/components/DataTable";
import ActionControlMenu from "@/components/ActionControlMenu";
import debounce from "lodash/debounce";
import {  mapGetters } from "vuex";


const url = require("../../client_config/config").url;

export default {
  mixins: [renameFileHelper],
  components: {
    ClientNav,
    ClientSide,
    Foot,
    DataTable,
    ActionControlMenu,
  },

  data: function () {
    return {
      headers: [
        {
          text: "Date Filled",
          align: "start",
          sortable: false,
          value: "DateFilled",
          width: "15%",
        },
        { text: "Medication", value: "Medication" },
        { text: "Quantity", value: "Quantity" },
        { text: "EnteredBy", value: "EnteredBy" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      tab: null,
      items: ["Medication Inventory", "Disabled Medication Inventory"],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      msg: false,
      search: "",
      text: "",
      inventories: [],
      disabledInventories: [],
      tempDataInventories: [],
      tempData: [],
      users: [],
      medications: [],
      staff: "",
      clientID: localStorage.getItem("clientId"),
      userID: localStorage.getItem("userID"),
      inventoryID: "",
      med: {},
      isLoading: true,
      uploadImg: "",
      lastUpdatedBy: "",
      staffID: null,
      previousQuantity: null,
      currentQuantity: null,
      searchKeyword: "",
      itemsPerPage: -1,
      currentPage: 1,
      pagination: {
        total: 0,
        pages: 0,
      },
      showActions: {
        add: true,
        print: true,
        download: true,
      },
      navigateTo: {},
      isActive: true,
      payload: {},
    };
  },
  computed: {
    ...mapGetters({
      client: "clients/clientData",
    }),

    userRole() {
      return this.$store.state.users.user.Role === "Administration";
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
     }
  },

  watch: {
    tab(newTab) {
      if (newTab === 0 || newTab === 1) {
        this.isActive = newTab === 0;
        this.fetchItem();
      }
    },
    client: {
      immediate: true,
      handler(client) {
        if (client) {
          this.initializePayload();
        }
      },
    },
    isAuditorRole(newVal) {
      this.showActions.add = !newVal; 
    }
  },

  mounted() {
    this.clientID = this.$route.params.clientID;
    this.fetchItem();
    this.navigateTo = {
      path: `/medicationInventory/${this.clientID}/add`,
      query: { createMedicationInventory: "true" },
    };
    this.showActions.add = !this.isAuditorRole;
  },

  methods: {
    initializePayload() {
      this.payload = {
        query: {
          name: this.client?.Name,
          clientId: this.client?._id,
          generateFile: true,
          page: this.currentPage,
          limit: this.itemsPerPage,
          keyword: this.searchKeyword,
          searchFields: this.headers
            .filter((h) => h.value !== "actions")
            .map((h) => h.value),
        },
        endpoints: `medicationInventory`,
        dynamic: true,
        fileName: `${this.client?.Name}-medication-inventory.pdf`,
      };
    },

    async fetchItem() {
      this.isLoading = true;
      this.inventories = [];
      try {
        const res = await axios.get(`${url}/medicationInventory`, {
          params: {
            clientId: this.clientID,
            isActive: this.isActive,
            page: this.currentPage,
            limit: this.itemsPerPage,
            keyword: this.searchKeyword,
            searchFields: this.headers
              .filter((h) => h.value !== "actions")
              .map((h) => h.value),
          },
        });

        this.pagination = res.data.pagination;

        this.inventories = res.data.results.map((item) => {
          const dateFilled = item?.DateFilled;
          let formattedDate = "";

          if (dateFilled) {
            const parsedDate = new Date(dateFilled);
            if (!isNaN(parsedDate.getTime())) {
              formattedDate = parsedDate.toISOString().substring(0, 10);
            }
          }
          return {
            ...item,
            DateFilled: formattedDate,
          };
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
        this.initializePayload()
      }
    },

    onViewItem(item) {
      this.$router.push({
        path: `/medicationInventory/${this.clientID}/update/${item._id}`,
        query: { createMedicationInventory: "false" },
      });
    },

    onDeleteItem(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this inventory item?") &&
        this.deleteItem(id);
    },

    deleteItem(id) {
      axios.delete(`${url}/medicationInventory/${id}`).then((response) => {
        if (response.status == 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }

        this.msg = true;
        this.text = "The inventory item has been deleted successfully.";
        this.fetchItem();
      });
    },

    handlePagination(options) {
      this.currentPage = options.page;
      this.itemsPerPage = options.itemsPerPage;
      this.fetchItem();
    },

    handleSearch: debounce(function (newKeyword) {
      this.searchKeyword = newKeyword;
      this.fetchItem();
    }, 300),

    handleActions(action) {
      if (this.$refs.actions) {
        this.$refs.actions[0].onSelectAction(action);
      } else {
        console.error("reference not found");
      }
    },
  },
};
</script>
